import { isWeb, SizableText, YStack } from '@my/ui'
import { H4 } from 'app/components'
import { JumpToLinksBlock } from './jump-to-links.block'
import { useJumpToLinksContext } from '../../contexts'

function chunkArray<T>(arr: T[], chunkSize: number): T[][] {
  const chunks: T[][] = []
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize))
  }
  return chunks
}

export const JumpToLinksComponent = (block: JumpToLinksBlock) => {
  const { jumpToLinks, scrollToSection } = useJumpToLinksContext()

  // TODO!!: Jump to link works on web now. need to find the way for it to work on native
  //Hide on mobile app for MVC
  if (!isWeb) {
    return <></>
  }

  const validLinks = block.links.filter((link) => {
    const jumpToLink = jumpToLinks.find((jumpToLink) => jumpToLink.blockName === link.jumpsTo)
    if (!jumpToLink) {
      console.warn(`Jump to link not found for ${link.jumpsTo}`)
      return false
    }
    return true
  })

  const linkChunks = chunkArray(validLinks, 5)
  if (!linkChunks || linkChunks.length < 0) return <></> //in case if there is no link and block match
  return (
    <YStack py="$4">
      <H4 pb="$4" size="$8" fow="600" color="$gray13">
        {block.jumpToLinkHeading}
      </H4>
      <YStack flex={1} flexDirection="row" justifyContent="flex-start">
        {linkChunks.map((chunk, index) => (
          <YStack
            key={index}
            space={4}
            backgroundColor="$primary4"
            borderRadius={12}
            py="$4"
            px="$3"
            height="100%"
            width="25%"
            marginRight="$2"
          >
            {chunk.map((link) => (
              <SizableText
                key={link.text}
                size="$4"
                textDecorationLine="underline"
                cursor="pointer"
                fow="500"
                onPress={() => {
                  const jumpToLink = jumpToLinks.find(
                    (jumpToLink) => jumpToLink.blockName === link.jumpsTo
                  )
                  if (!jumpToLink) {
                    console.warn(`Jump to link not found for ${link.jumpsTo}`)
                    return
                  }
                  scrollToSection(jumpToLink)
                }}
              >
                {link.text}
              </SizableText>
            ))}
          </YStack>
        ))}
      </YStack>
    </YStack>
  )
}
